<div class="agpr-createSourceInput">
    <label [id]="id + '_newSource_label'">{{ label | localize }}</label>
    <div
        class="agpr-createSourceInput-inputs"
        [ngClass]="{'agpr-createSourceInput-inputs--withChips': sourceChips && sourceChips.length}"
        role="group"
        [attr.aria-labelledby]="id + '_newSource_label'"
    >
        <agpr-dropdown
            [id]="id + '_sourceType'"
            class="agpr-createSourceInput-type"
            [options]="sourceTypeOptions"
            [(ngModel)]="selectedType"
            [ariaLabel]="'Sources.sourcePicker.create.type'"
        ></agpr-dropdown>
        <agpr-text-input
            #textInput
            [id]="id + '_sourceName'"
            class="agpr-createSourceInput-name"
            placeholder="Sources.sourcePicker.create.placeholder"
            [ariaLabel]="'Sources.sourcePicker.create.name'"
            [(ngModel)]="newSourceName"
            (keyup)="validateSources($event)"
            (blur)="validateSources()"
            [ariaInvalid]="sourceErrors.length > 0"
        ></agpr-text-input>
    </div>
    @if (sourceChips && sourceChips.length) {
        <div class="agpr-createSourceInput-chips">
            <agpr-scroll-panel>
                <ul>
                    <li
                        *ngFor="let chip of sourceChips; let i = index"
                        [id]="id + '_sources_chip_' + i"
                        class="agpr-chip"
                        [attr.aria-label]="chip.label"
                    >
                        <span class="agpr-chip-label">
                            {{ chip.label }}
                        </span>
                        <span class="agpr-chip-type">
                            {{ chip.type }}
                        </span>
                        <button
                            [id]="id + '_sources_chip_' + i + '_delete'"
                            class="agpr-chip-icon agpr-i-close"
                            agprTooltip="Common.forms.chips.delete"
                            [useTooltipAsAriaLabel]="false"
                            tooltipPosition="top"
                            (click)="removeSource(chip)"
                            [attr.aria-label]="chip.label + ' ' + ('Common.forms.chips.delete' | localize)"
                        ></button>
                    </li>
                </ul>
            </agpr-scroll-panel>
        </div>
    }
    <agpr-form-message
        *ngFor="let error of sourceErrors"
        class="agpr-createSourceInput-errors"
        [marginBottom]="0"
    >
        {{ error | localize }}
    </agpr-form-message>
</div>
